import './App.scss';
import Header from './component/_shared/header';
import MainContent from './component/_shared/mainContent';
import Footer from './component/_shared/footer';
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store/store';

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <Header />
                        <MainContent />
                    </PersistGate>
                </Provider>
                <Footer />
            </BrowserRouter>
        </div>
    );
}

export default App;